import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import saveFormRecord from "./saveFormRecord";

const saveNotAnswersLanding = async ({
  sessionID,
  landingId,
  state,
  prevForm,
  metadata = {},
}) => {
  const path = `IT/forms/cancelation-form/${sessionID}`;
  const docRef = doc(db, path);
  const newLanding = {
    landingId,
    landedAt: state.landedAt,
    submittedAt: Date.now(),
    metadata,
    answers: [],
  };

  const thisFieldExists = prevForm.items.some(
    (item) => item.landingId === landingId
  );
  const updateData = thisFieldExists
    ? [
        ...prevForm.items.filter((item) => item.landingId !== landingId),
        newLanding,
      ]
    : arrayUnion(newLanding);

  await saveFormRecord(sessionID, {
    ...prevForm,
    items: updateData,
  });
  await updateDoc(docRef, {
    items: updateData,
    processed: false
  });

  console.log("State successfully written to Firestore!");
};

export default saveNotAnswersLanding;
